module.exports = __webpack_public_path__ + "img/4cd9801.png";